import './dashboard.css'
import React, { useMemo, useEffect, useState, useContext } from 'react'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { apiUrl } from '../../context/constants/constants'

import { AuthContext } from '../../context/authContext/AuthContext'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import {
  Container,
  Grow,
  Grid,
  Typography,
  FormControl,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Button,
  Select,
  MenuItem
} from '@material-ui/core'

import Box from '@mui/material/Box'
import { DataGrid, GridColDef, GridActionsCellItem } from '@mui/x-data-grid'
import Delete from '@material-ui/icons/Delete.js'
import VisibilityIcon from '@material-ui/icons/Visibility.js'
import EditIcon from '@material-ui/icons/Edit.js'
import FileCopyIcon from '@material-ui/icons/FileCopy.js'
import GetAppIcon from '@material-ui/icons/GetApp'
import ImportExportIcon from '@material-ui/icons/ImportExport.js'
import moment from 'moment'
export default function Dashboard() {
  const history = useHistory()
  const URL = ''
  const MONTHS = useMemo(
    () => [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    []
  )

  const [showEmailLanding, setShowEmailLanding] = useState(false)
  const { isFetching, message, state, data, error, dispatch } =
    useContext(AuthContext)

  const [phoneValue, setPhoneValue] = useState()
  const [userIdEdit, setUserIdEdit] = useState('')

  const [showForm, setShowForm] = useState(false)
  const [showEditForm, setShowEditForm] = useState(false)
  const showAddAffiliateForm = () => {
    setShowEditForm(false)
    setShowForm(true)
    setPostData({
      FirstName: '',
      LastName: '',
      Instagram: '',
      Occupation: '',
      Email: '',
      Phone: '',
      Password: '',
      AffiliateID: '',
      ReferralLink: '',
      Status: true,
      commissionStructure1: '',
      commissionStructure2: '',
      commissionStructure3: '',
      createEmail: false
    })
  }

  const [postData, setPostData] = useState({
    FirstName: '',
    LastName: '',
    Instagram: '',
    Occupation: '',
    Email: '',
    Phone: '',
    Password: '',
    AffiliateID: '',
    ReferralLink: '',
    sendWelcomeEmail: false,
    sendSms: false,
    Status: false,
    commissionStructure1: '',
    commissionStructure2: '',
    commissionStructure3: '',
    createEmail: false
  })
  const [checked, setChecked] = useState(false)
  const [checkedSendMail, setCheckedSendMail] = useState(false)
  const [checkedSendSms, setCheckedSendSms] = useState(false)
  const [checkedGenerateLandingPage, setCheckedGenerateLandingPage] =
    useState(false)
  const copyEmail = (data) => {
    const tempInput = document.createElement('input')
    tempInput.value = `${apiUrl}/links/affiliate/welcome/${data}.html`
    document.body.appendChild(tempInput)
    tempInput.select()
    document.execCommand('copy')
    document.body.removeChild(tempInput)
    alert('Copied')
  }
  const editUser = async (userId) => {
    setShowForm(true)
    setShowEditForm(true)
    setUserIdEdit(userId)

    try {
      const res = await axios.get(`${apiUrl}/affiliate/getUserById/${userId}`)

      if (res.data.success) {
        setPostData({
          FirstName: res.data.data[0].FirstName,
          LastName: res.data.data[0].LastName,
          Instagram: res.data.data[0].Instagram,
          Occupation: res.data.data[0].Occupation,
          Email: res.data.data[0].Email,
          Phone: res.data.data[0].Phone,
          Password: res.data.data[0].Password,
          AffiliateID: res.data.data[0].AffiliateID,
          ReferralLink: res.data.data[0].ReferralLink,
          Status: res.data.data[0].Status,
          commissionStructure1: res.data.data[0].commissionStructure1,
          commissionStructure2: res.data.data[0].commissionStructure2,
          commissionStructure3: res.data.data[0].commissionStructure3,
          createEmail: res.data.data[0].createEmail
        })
        console.log('status', res.data.data[0].Status)
        setShowEmailLanding(res.data.data[0].createEmail)
      }
    } catch (error) {
      console.log(error)
    }
  }
  /* export csv */
  const [dataEnrollments, setDataEnrollments] = useState([])
  const [totalCommissions, setTotalCommissions] = useState(0)

  const [exportPostData, setExportPostData] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Password: '',
    AffiliateID: '',
    trackedUrl: '',
    lastUpdated: '',
    clicks: '',
    revenue: '',
    environments: '',
    commissionStructure1: '',
    commissionStructure2: '',
    commissionStructure3: ''
  })

  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index)
  }
  const commissionStructure = (revenue) => {
    let commission = 0
    let commission1 = Number(exportPostData.commissionStructure1)
    let commission2 = Number(exportPostData.commissionStructure2)
    let commission3 = Number(exportPostData.commissionStructure3)
    if (commission1 == '') {
      commission1 = 200
    }
    if (commission2 == '') {
      commission2 = 300
    }
    if (commission3 == '') {
      commission3 = 400
    }
    if (revenue <= 2500) {
      commission = commission1
    } else if (7000 > revenue && revenue >= 2501) {
      commission = commission2
    } else {
      commission = commission3
    }
    return commission
  }
  const getEnrollmentDetails = async (affiliateID, userId) => {
    try {
      const res = await axios.get(
        `${apiUrl}/affiliate/getEnrollmentDetails/${affiliateID}`
      )

      if (res.data.success) {
        let dataEnrollments = res.data.data

        let commission = 0
        for (let i = 0; i < dataEnrollments.length; i++) {
          dataEnrollments[i].id = dataEnrollments[i]._id
          commission += commissionStructure(dataEnrollments[i].revenue)
        }

        setTotalCommissions(commission)
        setDataEnrollments(res.data.data)

        console.log(res.data.data)
        console.log(commission)

        const res2 = await axios.get(
          `${apiUrl}/affiliate/getUserInfoById/${userId}`
        )
        //get total clicks
        let clicks = 0
        if (res2.data.success) {
          clicks = res2.data.data[0].clicks
        }
        const userData = {
          commission,
          clicks,
          data: res.data.data
        }

        // const userData = {
        //   commission: 200,
        //   clicks: 43,
        //   data: [
        //     {
        //       studentName: 'Janessa Doretti',
        //       revenue: 2495,
        //       closeDate: '2025-03-01',
        //       enrollmentStatus: 'Graduated',
        //       environment: 1
        //     },
        //     {
        //       studentName: 'Michael Scott',
        //       revenue: 1500,
        //       closeDate: '2025-04-15',
        //       enrollmentStatus: 'Enrolled',
        //       environment: 2
        //     },
        //     {
        //       studentName: 'Pam Beesly',
        //       revenue: 3000,
        //       closeDate: '2025-05-20',
        //       enrollmentStatus: 'Graduated',
        //       environment: 1
        //     }
        //   ]
        // }

        const calculateCommission = (revenue) => {
          if (revenue >= 1 && revenue <= 2500) return 200
          if (revenue >= 2501 && revenue <= 7000) return 300
          return 400
        }

        const generateComplexCSV = (data) => {
          let csv = ''

          // ---- PHẦN 1: DATA ARRAY ----
          const studentHeaders = [
            'Student Name',
            'Revenue',
            'Commission',
            'Completion Date'
          ]
          csv += studentHeaders.join(',') + '\n'
          const totalEnrollment = data.data.length
          data.data.forEach((student) => {
            const commissionValue = calculateCommission(student.revenue)

            const row = [
              student.studentName,
              student.revenue,
              commissionValue,
              student.closeDate
            ].join(',')

            csv += row + '\n'
          })

          csv += '\n'

          // ---- PHẦN 2: COMMISSION & CLICKS ----
          const commissionHeaders = [
            'Total Enrollments',
            'Total Commissions',
            'Total Click'
          ]
          csv += commissionHeaders.join(',') + '\n'
          csv +=
            [totalEnrollment, data.commission, data.clicks].join(',') + '\n'

          return csv
        }

        const csvContent = generateComplexCSV(userData)

        // đảm bảo chạy trên browser
        if (typeof window === 'undefined') return

        const blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8'
        })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = `Affiliate_Report_${affiliateID}.csv`
        document.body.appendChild(link)
        link.click()

        // cleanup
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const exportCSV = async (userId, affiliateId) => {
    //  await getUserInfoById(userId)
    await getEnrollmentDetails(affiliateId, userId)
  }
  const sendSMS = (smsContent, phoneNumber) => {
    fetch(`${apiUrl}/smsmessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ message: smsContent, to: phoneNumber })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          //  alert('success')
          alert('SMS sent successfully!')
        } else {
          alert('SMS sent unsuccessfully!')
        }
      })
  }
  /* end export  */
  const viewUser = (userId, affiliateId) => {
    history.push(URL + '/user', { userId, affiliateId })
  }
  const [listUsers, setListUsers] = useState([])
  const [searchUsers, setSearchUsers] = useState([])

  const [userStats, setUserStats] = useState([])
  const [fileStats, setFileStats] = useState([])

  const formatPhoneNumber = (value) => {
    let formattedNumber

    const { length } = value
    // Filter non numbers
    const regex = () => value.replace(/[^0-9\.]+/g, '')
    // Set area code with parenthesis around it
    const areaCode = () => `(${regex().slice(0, 3)})`

    // Set formatting for first six digits
    const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`

    // Dynamic trail as user types
    const trailer = (start) => `${regex().slice(start, regex().length)}`
    if (length < 3) {
      // First 3 digits
      formattedNumber = regex()
    } else if (length === 4) {
      // After area code
      formattedNumber = `${areaCode()} ${trailer(3)}`
    } else if (length === 5) {
      // When deleting digits inside parenthesis
      formattedNumber = `${areaCode().replace(')', '')}`
    } else if (length > 5 && length < 9) {
      // Before dash
      formattedNumber = `${areaCode()} ${trailer(3)}`
    } else if (length >= 10) {
      // After dash
      formattedNumber = `${firstSix()}-${trailer(6)}`
    }
    //  console.log(formattedNumber)
    return formattedNumber
  }
  const columns: GridColDef<(typeof rows)[number]>[] = [
    { field: 'id', headerName: 'ID', width: 1, hide: true, editable: true },

    {
      field: 'fullName',
      headerName: 'Name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 160,
      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Name
          </span>
          <span className='contentForMobile'>
            {value.row.FirstName || ''} {value.row.LastName || ''}
          </span>
        </p>
      )
    },
    {
      field: 'Email',
      headerName: 'Email',
      width: 150,
      editable: false,

      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Email
          </span>
          <span className='contentForMobile'>{value.row.Email || ''}</span>
        </p>
      )
    },
    {
      field: 'Phone',
      headerName: 'Phone',
      width: 130,
      editable: false,
      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Phone
          </span>
          <span className='contentForMobile'>
            {formatPhoneNumber(value.row.Phone)}
          </span>
        </p>
      )
    },
    {
      field: 'affiliateId',
      headerName: 'Affiliate ID',
      width: 150,
      editable: false,
      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Affiliate ID
          </span>
          <span className='contentForMobile'>{value.row.affiliateId}</span>
        </p>
      )
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 90,
      editable: false,
      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Status
          </span>
          <span
            title={
              value.row.Status === true || value.row.Status === null
                ? 'Active'
                : 'Deactivate'
            }
            className={
              value.row.Status === true || value.row.Status === null
                ? 'Active contentForMobile'
                : 'Deactivate contentForMobile'
            }
          >
            {value.row.Status === true || value.row.Status === null
              ? 'Active'
              : 'Deactivate'}
          </span>
        </p>
      )
    },
    {
      field: 'clicks',
      headerName: 'Clicks',
      width: 70,
      editable: false,
      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Clicks
          </span>
          <span className='contentForMobile'>{value.row.clicks}</span>
        </p>
      )
    },
    {
      field: 'environments',
      headerName: 'Enrollments',
      width: 100,
      editable: false,
      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Enrollments
          </span>
          <span className='contentForMobile'>{value.row.environments}</span>
        </p>
      )
    },
    {
      field: 'revenue',
      headerName: 'Revenue',
      width: 80,
      editable: false,
      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Revenue
          </span>
          <span className='contentForMobile'>{value.row.revenue}</span>
        </p>
      )
    },
    {
      field: 'lastUpdated',
      headerName: 'Last Updated',
      width: 150,
      editable: false,
      renderCell: (value, row) => (
        <p className='wrapForMobile'>
          <span className='titleForMobile' style={{ display: 'none' }}>
            Last Updated
          </span>
          <span className='contentForMobile'>
            {value.row.lastUpdated
              ? moment(value.row.lastUpdated).format('MM/DD/YYYY HH:ss')
              : ''}
          </span>
        </p>
      )
    },
    {
      field: 'actions',
      type: 'actions',
      width: 180,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<GetAppIcon />}
          label='Export'
          onClick={() => exportCSV(params.row._id, params.row.affiliateId)}
        />,
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label='View'
          onClick={() => viewUser(params.row._id, params.row.affiliateId)}
        />,

        <GridActionsCellItem
          icon={<FileCopyIcon />}
          style={{ display: params.row.createEmail == true ? 'block' : 'none' }}
          label='Copy Email Url'
          onClick={() => copyEmail(params.row.affiliateId)}
        />,
        <GridActionsCellItem
          icon={<EditIcon />}
          label='Edit'
          onClick={() => editUser(params.row._id)}
        />,
        <GridActionsCellItem
          icon={<Delete />}
          label='Delete'
          onClick={() => {
            // eslint-disable-next-line no-restricted-globals
            if (window.confirm('Are you sure you want to delete?')) {
              //eslint-disable-line
              //eslint-disable-line
              // eslint-disable-next-line no-restricted-globals
              if (window.confirm('Do you want to delete this user account?')) {
                //eslint-disable-line
                // code here for save then leave (Yes)
                deleteAffiliateUser(params.row._id, params.row.affiliateId)
              } else {
                //code here for no save but leave (No)
                deleteAffiliate(params.row._id, params.row.affiliateId)
              }
            } else {
              //code here for don't leave (Cancel)
            }
          }}
        />
      ]
    }
  ]

  let rows = []
  if (listUsers) {
    rows = listUsers
  }
  const deleteAffiliateUser = async (id, affiliateId) => {
    try {
      const deleteStRecord = await axios.delete(
        `${apiUrl}/affiliate/deleteAffiliateUser?Id=${id}&AffiliateID=${affiliateId}`
      )

      alert(deleteStRecord.data.message)
      getAllUsers()
    } catch (error) {
      console.log(error)
    }
  }
  const deleteAffiliate = async (id, affiliateId) => {
    try {
      const deleteStRecord = await axios.delete(
        `${apiUrl}/affiliate/deleteAffiliate?Id=${id}&AffiliateID=${affiliateId}`
      )

      //  alert(res2.data.message)

      alert(deleteStRecord.data.message)
      getAllUsers()
    } catch (error) {
      console.log(error)
    }
  }
  const getAllUsers = async () => {
    try {
      const res = await axios.get(`${apiUrl}/affiliate/getAllUsers`)

      setListUsers(res.data.data)
      setSearchUsers(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }
  const filterBySearch = (event) => {
    // Access input value
    const query = event.target.value

    // Create copy of item list
    var updatedList = [...listUsers]

    // Include all elements which includes the search query
    updatedList = updatedList.filter(
      (item) => item.FirstName.toLowerCase().indexOf(query.toLowerCase()) !== -1
    )

    // Trigger render with updated values
    setSearchUsers(updatedList)
  }
  const handleCancel = () => {
    setShowForm(false)
    setPostData({
      FirstName: '',
      LastName: '',
      Instagram: '',
      Occupation: '',
      Email: '',
      Phone: '',
      Password: '',
      AffiliateID: '',
      ReferralLink: '',
      Status: false,
      commissionStructure1: '',
      commissionStructure2: '',
      commissionStructure3: '',
      createEmail: false
    })
  }
  const handleChange = (e) => {
    if (e != '' && e.target === undefined) {
      setPostData({ ...postData, Phone: e })
    } else {
      const { name, value } = e.target

      if (name === 'Status') {
        setChecked(!checked)

        setPostData({ ...postData, Status: checked })
      } else if (name === 'sendWelcomeEmail') {
        setCheckedSendMail(!checkedSendMail)
        setPostData({ ...postData, sendWelcomeEmail: checkedSendMail })
      } else if (name === 'sendSms') {
        console.log('checkedSendSms', checkedSendSms)
        setCheckedSendSms(!checkedSendSms)
        setPostData({ ...postData, sendSms: checkedSendSms })
      } else if (name === 'generateLandingPage') {
        setCheckedGenerateLandingPage(!checkedGenerateLandingPage)
        setPostData({ ...postData, createEmail: checkedGenerateLandingPage })
      } else {
        setPostData({ ...postData, [name]: value })
      }
    }
  }
  const handleSignUp = async (e) => {
    e.preventDefault()
    const data = {
      FirstName: postData.FirstName.trim(),
      LastName: postData.LastName.trim(),
      Instagram: postData.Instagram,
      Occupation: postData.Occupation,
      Email: postData.Email.trim(),
      Phone: postData.Phone,
      Password: postData.Password.trim(),
      AffiliateID: postData.AffiliateID.trim(),
      ReferralLink: postData.ReferralLink.trim(),
      sendWelcomeEmail: checkedSendMail,
      sendSms: checkedSendSms,
      userId: userIdEdit,
      Status: postData.Status,
      commissionStructure1: postData.commissionStructure1.trim(),
      commissionStructure2: postData.commissionStructure2.trim(),
      commissionStructure3: postData.commissionStructure3.trim(),
      createEmail: postData.createEmail
    }
    if (postData.FirstName === '') {
      alert('First name is required!')
      return
    }
    if (postData.LastName === '') {
      alert('Last name is required!')
      return
    }
    if (postData.Email === '') {
      alert('Email is required!')
      return
    }
    console.log(postData.Phone)
    if (postData.Phone === '') {
      alert('Phone is required!')
      return
    }
    if (postData.AffiliateID === '') {
      alert('AffiliateID is required!')
      return
    }
    if (postData.Password === '') {
      alert('Password is required!')
      return
    }
    if (showEditForm) {
      //update  user
      try {
        const res = await axios.put(apiUrl + '/affiliate/updateUser', data)
        alert(res.data.message)
        // console.log(res)
        console.log('checkedSendSms', checkedSendSms)
        console.log('checkedGenerateLandingPage', postData.createEmail)
        if (checkedSendSms) {
          if (postData.createEmail) {
            let smsContent = `${apiUrl}/links/affiliate/welcome/${postData.AffiliateID}.html`
            sendSMS(smsContent, '+16023302778')
          }
        }
        getAllUsers()
        setShowForm(false)
      } catch (err) {
        alert(err.response.data.message)
        console.log(err)
      }
    } else {
      try {
        const res = await axios.post(apiUrl + '/affiliate/createUser', data)
        // console.log(res)
        alert(res.data.message)
        handleCancel()
        getAllUsers()
        // res.data.result.isAdmin && dispatch(loginSuccess(res.data))
      } catch (err) {
        alert(err.response.data.message)
      }
    }
  }

  useEffect(() => {
    if (message) {
      alert(message.message.data.message)
    }
    getAllUsers()
    const getStats = async () => {
      try {
        const res = await axios.get(`${apiUrl}/affiliate/stats`)
        // setUserStats(res.data)
        const statsList = res.data.sort(function (a, b) {
          return a._id - b._id
        })
        statsList.map((item) =>
          setUserStats((prev) => [
            ...prev,
            { name: MONTHS[item._id - 1], 'New User': item.total }
          ])
        )
      } catch (error) {
        console.log(error)
      }
    }

    // const getFileStats = async () => {
    //   try {
    //     const res = await axios.get(`${apiUrl}/posts/postStats`)

    //     //home.css setFileStats(res.data)
    //     let fileStartsList = res.data
    //     fileStartsList = res.data.sort(function (a, b) {
    //       const data1 = new Date(a._id).getTime()
    //       const data2 = new Date(b._id).getTime()
    //       return data1 - data2
    //     })

    //     fileStartsList.map((item) => {
    //       setFileStats((prev) => [
    //         ...prev,
    //         { name: item._id, 'New Files': item.totalFile }
    //       ])
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
    // getFileStats()
    getStats()
    setChecked(postData.Status)
    // console.log(data)
    // if (data.data) {
    //   console.log(data.data.length)
    // }

    // if (data && data.data.data.length > 0) {
    //   console.log(data)
    //   setPostData({
    //     FirstName: data.data.data[0].FirstName,
    //     LastName: data.data.data[0].LastName,
    //     Email: data.data.data[0].Email,
    //     Phone: data.data.data[0].Phone,
    //     Password: data.data.data[0].Password,
    //     AffiliateID: data.data.data[0].AffiliateID
    //   })
    // }
  }, [MONTHS, message, data, showEmailLanding])
  return (
    <Grow in>
      <Container style={{ marginTop: '50px' }}>
        <div className='addAffiliate'>
          <Grid
            container
            justifyContent='space-between'
            alignItems='stretch'
            spacing={3}
            className='wrapper'
          >
            <Grid item xs={12} sm={12}>
              <Button
                className='addAffiliate'
                onClick={() => showAddAffiliateForm()}
              >
                <Typography className='changeClass'>Add Affiliate</Typography>
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              style={{ display: showForm == true ? 'block' : 'none' }}
            >
              <form
                encType='multipart/form-data'
                autoComplete='off'
                noValidate
                className='formAddAffiliate'
              >
                <Typography
                  variant='h6'
                  style={{ fontWeight: '300', fontSize: '15px' }}
                >
                  {showEditForm ? 'Update Affiliate' : 'Add Affiliate'}
                </Typography>
                <FormControl fullWidth className='formControl'>
                  <div className='wrapFullName'>
                    <TextField
                      required
                      className='fileInput'
                      name='FirstName'
                      variant='outlined'
                      label='Enter First Name'
                      fullWidth
                      value={postData.FirstName || ''}
                      onChange={(e) => handleChange(e)}
                    />

                    <TextField
                      className='fileInput'
                      name='LastName'
                      required
                      variant='outlined'
                      label='Enter Last Name'
                      fullWidth
                      value={postData.LastName || ''}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </FormControl>
                <FormControl fullWidth className='formControl'>
                  <PhoneInput
                    disableCountryCode={true}
                    placeholder='Enter phone number'
                    value={postData.Phone || ''}
                    country={'us'}
                    onlyCountries={['us']}
                    masks={{ us: '(...) ...-....' }}
                    onChange={(e) => handleChange(e)}
                    name='Phone'
                  />
                </FormControl>
                <FormControl fullWidth className='formControl'>
                  <TextField
                    className='fileInput'
                    name='Email'
                    required
                    variant='outlined'
                    label='Enter Email'
                    fullWidth
                    value={postData.Email || ''}
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>
                <FormControl fullWidth className='formControl'>
                  <TextField
                    className='fileInput'
                    name='Instagram'
                    variant='outlined'
                    label='Enter Instagram'
                    fullWidth
                    value={postData.Instagram || ''}
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>
                <FormControl fullWidth className='formControl SelectOccupation'>
                  <Select
                    className='fileInput'
                    name='Occupation'
                    variant='outlined'
                    label='Select Occupation'
                    fullWidth
                    value={postData.Occupation || ''}
                    onChange={(e) => handleChange(e)}
                  >
                    <MenuItem value={''}>select Occupation</MenuItem>
                    <MenuItem value={'Cosmetic Injector'}>
                      Cosmetic Injector
                    </MenuItem>
                    <MenuItem value={'Laser Tech'}>Laser Tech</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth className='formControl'>
                  <TextField
                    className='fileInput'
                    name='AffiliateID'
                    required
                    variant='outlined'
                    label='Affiliate ID'
                    fullWidth
                    value={postData.AffiliateID || ''}
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>

                <FormControl fullWidth className='formControl'>
                  <TextField
                    className='fileInput'
                    name='ReferralLink'
                    variant='outlined'
                    label='Referral Link'
                    fullWidth
                    value={postData.ReferralLink || ''}
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>
                <FormControl fullWidth className='formControl'>
                  <label className='commissionStructureLabel'>
                    Commission Structure
                  </label>
                  <div className='commissionStructureGroup'>
                    <TextField
                      className='fileInput'
                      name='commissionStructure1'
                      type='number'
                      variant='outlined'
                      label=''
                      fullWidth
                      value={postData.commissionStructure1 || ''}
                      onChange={(e) => handleChange(e)}
                    />
                    <label>per enrollment (Revenue: $1 - $2,500)</label>
                  </div>
                </FormControl>
                <FormControl fullWidth className='formControl'>
                  <div className='commissionStructureGroup'>
                    <TextField
                      className='fileInput'
                      name='commissionStructure2'
                      type='number'
                      variant='outlined'
                      label=''
                      fullWidth
                      value={postData.commissionStructure2 || ''}
                      onChange={(e) => handleChange(e)}
                    />
                    <label>per enrollment (Revenue: $2,501 - $7,000)</label>
                  </div>
                </FormControl>
                <FormControl fullWidth className='formControl'>
                  <div className='commissionStructureGroup'>
                    <TextField
                      className='fileInput'
                      name='commissionStructure3'
                      type='number'
                      variant='outlined'
                      label=''
                      fullWidth
                      value={postData.commissionStructure3 || ''}
                      onChange={(e) => handleChange(e)}
                    />
                    <label>per enrollment (Revenue: $7,001+)</label>
                  </div>
                </FormControl>

                <FormControl className='formControl' fullWidth>
                  <TextField
                    id='demo-simple-select-password'
                    className='fileInput'
                    name='Password'
                    variant='outlined'
                    label='Password'
                    type='password'
                    autoComplete='true'
                    fullWidth
                    value={postData.Password || ''}
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name='Status'
                        onChange={(e) => handleChange(e)}
                        checked={!postData.Status}
                      />
                    }
                    label='Deactivate'
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name='sendWelcomeEmail'
                        onChange={(e) => handleChange(e)}
                      />
                    }
                    label='Send Welcome Email'
                  />
                </FormGroup>
                <FormGroup style={{ display: 'none' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name='sendSms'
                        onChange={(e) => handleChange(e)}
                      />
                    }
                    label='Send Sms'
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name='generateLandingPage'
                        onChange={(e) => handleChange(e)}
                        checked={postData.createEmail}
                      />
                    }
                    label='Generate Landing Page'
                  />
                </FormGroup>

                <FormControl
                  fullWidth
                  className='formControl'
                  style={{
                    display: showEmailLanding === true ? 'block' : 'none'
                  }}
                >
                  <div>
                    <div className='commissionStructureGroup'>
                      <label className='commissionStructureLabel'>
                        Landing Page
                      </label>
                    </div>
                    <div className='commissionStructureGroup'>
                      <label>
                        <a
                          href={`${apiUrl}/links/affiliate/welcome/${postData.AffiliateID}.html`}
                          target='_blank'
                          rel='noreferrer'
                        >
                          {postData.AffiliateID}.html
                        </a>
                      </label>
                    </div>
                  </div>
                </FormControl>
                <FormControl className='formControl' fullWidth>
                  <Button
                    className='buttonSubmit'
                    variant='contained'
                    color='primary'
                    size='large'
                    type='button'
                    onClick={handleSignUp}
                    disabled={isFetching}
                  >
                    {showEditForm ? 'Update Affiliate' : 'Add Affiliate'}
                  </Button>
                  <Button
                    className='buttonCancel'
                    variant='contained'
                    color='primary'
                    size='large'
                    type='button'
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </Button>
                </FormControl>
              </form>
            </Grid>
          </Grid>
        </div>
        <div className='manageAffiliate' style={{ marginTop: '50px' }}>
          <Grid
            container
            justifyContent='space-between'
            alignItems='stretch'
            spacing={3}
            className='wrapper'
          >
            <Grid item xs={12} sm={12}>
              <div className='wrapSearch'>
                <div className='search-header'>
                  <input
                    id='search-box'
                    placeholder='Search by first name'
                    onChange={filterBySearch}
                  />
                </div>
              </div>
              <Box sx={{ height: 400, width: '100%' }}>
                <DataGrid
                  columnVisibilityModel={{
                    id: false
                  }}
                  getEstimatedRowHeight={() => 100}
                  getRowHeight={() => 'auto'}
                  rows={searchUsers}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 20
                      }
                    }
                  }}
                  pageSizeOptions={[5]}
                  disableRowSelectionOnClick
                />
              </Box>
            </Grid>
          </Grid>
        </div>
      </Container>
    </Grow>
  )
}
